import makeStyles from '@mui/styles/makeStyles';

const getTextProperties = (fontSize: string) => ({
  fontFamily: "Manrope",
  fontWeight: 700,
  fontSize,
  color: "#465869",
});

const styles = makeStyles(() => ({
  container: {
    position: "relative",
    paddingBottom: "40px",
    overflowX: "hidden",
  },
  title: {
    ...getTextProperties("20px"),
  },
  subTitle: {
    ...getTextProperties("18px"),
    marginBottom: "24px",
  },

  header: {
    marginTop: "32px",
  },

  materials: {
    marginTop: "32px",
  },

  buttons: {
    position: "absolute",
    bottom: 0,
    right: 0,
  },
  separator: {
    backgroundColor: "#E0E2E7",
    height: "1px",
    width: "100%",
    margin: "32px 0px",
  },

  service: { width: "17%", marginRight: "1%" },
  charge: { width: "10.5%", marginRight: "1%" },
  quantity: { width: "6%", marginRight: "1%" },
  rate: { width: "9%", marginRight: "1%" },
  markUp: { width: "8%", marginRight: "1%" },
  margin: { width: "8%", marginRight: "1%" },
  discount: { width: "7.5%", marginRight: "1%" },
  currency: { width: "13%", marginRight: "1%" },
  subTotal: { width: "7%", marginRight: "1%" },
  actions: { width: "4%" },

  serviceView: { width: "27.5%", marginRight: "1%" },
  chargeView: { width: "16.5%", marginRight: "1%" },
  quantityView: { width: "15%", marginRight: "1%" },
  currencyView: { width: "20%", marginRight: "1%" },
  subTotalView: { width: "15%", marginRight: "1%" },

  agentSection: {
    marginTop: "32px",
  },
  agentHeader: {
    marginBottom: "24px",
  },
  agentContent: {},
  agentName: {
    color: "#667085",
    fontFamily: "Manrope",
    fontWeight: 500,
    fontSize: "15px",
  },
  agentPriceLastUpdate: {
    ...getTextProperties("14px"),
  },

  costContainer: {},
  costLabel: {
    ...getTextProperties("19px"),
    textTransform: "uppercase",
  },
  costValue: {
    ...getTextProperties("19px"),
  },

  paymentContainer: {
    marginTop: "24px",
  },
  paymentLabel: {
    ...getTextProperties("16px"),
  },
  chevronIcon: {
    width: 34,
    height: 34,
    borderRadius: "50%",
    backgroundColor: "#EDF5FB",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  locationTitle: {
    font: "600 14px/24px Manrope",
    color: "#308CDB",
    marginBottom: 10,
  },
  locationText: {
    font: "500 14px/24px Manrope",
    color: "#465869",
  },
  mt28: {
    marginTop: 28,
  },
}));

export default styles;
